module.exports = __webpack_public_path__ + "img/carspace.052fba27.png";